import { getItemUserStatus } from '../components/utils'
import css from './sass/itembid.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import { formatMoney } from 'services/util'

export default function FixedItemBidInfo({ item, auctionState, currentUserId, auction }) {

  const limitReached = () => {
    if (typeof item.LimitPerPerson === 'number' && item.MyAmountPurchased === item.LimitPerPerson) return true
    return false 
  }

  const generateQuantityText = (value) => {
    if (value === undefined || value === null) return 'Unlimited'
    if (value === 0) return 'Sold Out'
    else return formatMoney(value)
  }

  return (
    <div className={css['high-bid-container']}>
      <div className={css['high-bid-header']}>
        { auctionState !== 'ended' && <div>
          <p className={`${css['bid-text']} `}> Item Price</p>
          <p className={`${css['bid-text-large']} `}>${formatMoney(item.PurchasePrice)}</p>
        </div>}
        { auctionState === 'ended' && <div className={css['ended-fixed-item-info']}>
          <div>
            <p className={`${css['bid-text']} `}> Quantity Purchased</p>
            <p className={`${css['bid-text-large']} `}>{item.MyAmountPurchased} item(s)</p>
          </div>
          <div>
            <p className={`${css['bid-text']} `}> Total Price</p>
            <p className={`${css['bid-text-large']} `}>${formatMoney(item.PurchasePrice * item.MyAmountPurchased)}</p>
          </div>
        </div>}
        {item?.MyAmountPurchased > 0 &&
          <>
            <p className={limitReached() ? themeCss['hidden'] : themeCss['purchase-notification']}>
              Quantity purchased: {formatMoney(item.MyAmountPurchased)}
            </p>
            <p className={limitReached() ? themeCss['outbid-notification'] : themeCss['hidden']}>
              Max quantity purchased
            </p>
          </>
          }
      </div>

      <div className={css['bid-info-box']}>
        { auctionState === 'started' ? <p>Remaining: {generateQuantityText(item.TotalItemsRemaining)}</p> : <></> }
        { auctionState === 'started' ? <p>Quantity Limit per person: {generateQuantityText(item.LimitPerPerson)}</p> : <></> }
        { auctionState === 'ended' ? <p>Item Price: ${formatMoney(item.PurchasePrice)}</p> : <p>Fair Market Value: ${formatMoney(item.Value)}</p>}
      </div>
    </div>
  )
}
